import {OrderStatus} from '@wix/events-types'
import {
  getEventTitle,
  getPreliminaryInvoice,
  getTaxConfig,
  isAssignedTickets,
  isDateTbd,
} from '@wix/wix-events-commons-statics'
import {withTranslation} from '@wix/yoshi-flow-editor'
import {ReservationState} from '../../../../../../commons/enums'
import {isTemplate} from '../../../../../../commons/selectors/instance'
import {ticketsHaveSeats} from '../../../../../../commons/selectors/tickets'
import {getEvent} from '../../../selectors/event'
import {showGroupCard} from '../../../selectors/groups'
import {isPreparingOrder} from '../../../selectors/placed-order'
import {getPreliminaryInvoiceItems} from '../../../selectors/selected-tickets'
import {getTickets} from '../../../selectors/tickets'
import {State} from '../../../types'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {OrderSuccessRuntimeProps} from './interfaces'
import {OrderSuccess as Presentation} from './order-success'

const getOrderForDemoFlow = (state: State): wix.events.ticketing.Order => {
  const {checkout} = state

  const tickets = Object.keys(state.selectedTickets).map(key => ({
    ticketDefinitionId: key,
    ...getTickets(state).find(ticket => ticket.id === key),
  }))

  return {
    firstName: checkout.buyerDetails.firstName,
    email: checkout.buyerDetails.email,
    invoice: getPreliminaryInvoice(
      getTickets(state),
      getPreliminaryInvoiceItems(state),
      getTaxConfig(getEvent(state)) as wix.events.TaxConfig,
    ),
    status: OrderStatus.FREE,
    tickets,
    ticketsQuantity: tickets.length,
  }
}

const mapRuntime = ({state, actions: {ticketedThankYouPageLoaded}}: DetailsPageAppProps): OrderSuccessRuntimeProps => {
  const event = getEvent(state)
  const template = isTemplate(state)

  const order = template ? getOrderForDemoFlow(state) : state.placedOrder.order

  return {
    order,
    formattedOrderCreatedDate: state.dates.common.formattedOrderCreatedDate,
    eventTitle: getEventTitle(event),
    dateTbd: isDateTbd(event),
    isAssignedTickets: isAssignedTickets(event),
    taxConfig: getTaxConfig(event) as wix.events.TaxConfig,
    showGroup: showGroupCard(state),
    template,
    orderPending:
      state.navigation.reservationState === ReservationState.PENDING || order?.status === OrderStatus.PENDING,
    ticketedThankYouPageLoaded,
    orderHasSeats: ticketsHaveSeats(order?.tickets),
    loading: isPreparingOrder(order),
  }
}

export const OrderSuccess = connect<{}, OrderSuccessRuntimeProps>(mapRuntime)(withTranslation()(Presentation))

export * from './interfaces'
